
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../../components/Navbar.js";
import Select from "react-select";
import Swal from "sweetalert2";
import Resizer from "react-image-file-resizer";
import LOGO from "../../../assets/images/logo.png";
import SignatureCanvas from 'react-signature-canvas';
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
    getimgBase64,

    report_01,
    report_02,
    report_03,
    report_04,
    report_05
} from "../../../components/CustomComponent.js";

import "../../../components/global.js";
import "../../../assets/css/bootstrap.css";
import "../../../assets/css/index.css";

import province from "../../../assets/files/province.json"
import district from "../../../assets/files/district.json"
import subdistrict from "../../../assets/files/subdistrict.json"

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modal_signature: false,

            loading: false,
            tab: 1,

            goods_issuance_code: "",
            quotation_number: "",
            license_plate: "",
            member_name: "",
            job_id: "",
            job_number: "",
            brand_name: "",
            model_name: "",
            address: "",
            job_status: "1",
            phone_number: "",
            type: "",
            repair_date: new Date(),
            complete_date: null,
            due_date: null,
            policy_number: "",
            chassis_number: "",
            machine_number: "",
            technician_name: "",
            claim_number: "",
            reference_number: "",

            note: "",

            product_list: [],

            picture_list_bf: [],
            picture_list_af: [],

            history_list: [],

            data_product: [],
            data_admin: [],
            data_member: [],
            data_license_plate: [],
            data_quotation: [],
            data_job: [],

            product_id: "",
            product_type: "",
            qty: "",
            price: "",
            discount: "",
            estimated_price: "",
            payment_type: 1,
            installments: [],
            insurance_name: "",
            remark: "",

            cs_full_name: "",
            cs_age: "",
            cs_relation: "",
            cs_addess: "",
            cs_village: "",
            cs_street: "",
            cs_district: "",
            cs_sub_district: "",
            cs_province: "",
            cs_phone: "",

            signature_get_car: "",
            signature_repair: "",
            signature_witness: "",

            signature_get_car2: "",
            signature_repair2: "",
            signature_witness2: "",

            litigant_name: "",
            other_t1: "",

            repair_01: "",
            repair_02: "",
            repair_03: "",
            repair_04: "",
            repair_05: "",
            repair_06: "",
            repair_07: "",
            repair_08: "",
            repair_09: "",
            repair_10: "",
            repair_11: "",
            repair_12: "",
            repair_13: "",
            repair_14: "",

            oil: false,
            tool: false,
            spare_tire: false,
            air: false,
            air_text: "",
            other_t3: false,
            other_t3_text: "",
            driver_license: false,
            copy_license_plate: false,
            insurance_policy: false,
            id_card_owner: false,
            copy_certified_company: false,

            type_signature: "",
            readOnly: false,
            check: false,

            discount_by_item:""
        }
    }
    async componentDidMount() {
        this.setState({ loading: true });
        await this.Get();
        await this.getProductAll();
        await this.GetAdmin();
        await this.GetMember();
        await this.GetQuotation();
        if (this.props.location.query.id) {
            this.GetById(this.props.location.query.id)
        }
        if (this.props.location.query.type === "read") {
            this.setState({ readOnly: true })
        }
        this.setState({ loading: false });
    }

    Get = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: ""
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result);
            this.setState({ data_job: result.data.filter(e => e.job_status < 6).map(e => { return { label: e.job_number, value: e.job_id } }) });
        }
        this.setState({ loading: false });
    }
    GetById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            job_id: id
        }
        let result = await GET(tokens, "v1/TH/job-repair/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log(result.data);
            let quotation_number = result.data.quotation_number ? this.state.data_quotation.filter(e => e.value === result.data.quotation_number)[0] : ""
            this.setState({
                job_id: id,
                job_number: { value: id, label: result.data.job_number },

                goods_issuance_code: result.data.goods_issuance_code,
                quotation_number: quotation_number,
                license_plate: result.data.license_plate ? this.state.data_license_plate.filter(e => e.value === result.data.license_plate)[0] : "",
                member_name: result.data.member_name ? this.state.data_member.filter(e => e.value === result.data.member_name)[0] : "",
                brand_name: result.data.brand_name,
                model_name: result.data.model_name,
                address: result.data.address,
                job_status: result.data.job_status,
                phone_number: result.data.phone_number,
                type: result.data.type,
                repair_date: result.data.repair_date,
                complete_date: result.data.complete_date,

                due_date: result.data.due_date,
                policy_number: result.data.policy_number,
                chassis_number: result.data.chassis_number,
                machine_number: result.data.machine_number,
                technician_name: result.data.technician_name ? { value: result.data.technician_name, label: result.data.technician_name } : "",
                claim_number: result.data.claim_number,
                payment_type: result.data.payment_type,
                installments: result.data.installments,
                installments_count: result.data.installments.length,

                product_list: result.data.product_list.map(item => {
                    return {
                        cjd_id: item.cjd_id,
                        product_type: item.product_id ? this.state.data_product.filter(e => e.value === item.product_id)[0].product_type : "",
                        product_id: item.product_id ? this.state.data_product.filter(e => e.value === item.product_id)[0] : "",
                        qty: item.qty,
                        price: item.price,
                        discount_by_item: item.discount_by_item,
                        estimated_price: item.estimated_price,
                        total_price: (item.qty * item.estimated_price)*((100-item.discount_by_item)/100)
                    }
                }),
                history_list: result.data.job_history,
                picture_list_bf: result.data.picture_list_bf.map(e => { return e.picture }),
                picture_list_af: result.data.picture_list_af.map(e => { return e.picture }),
                insurance_name: result.data.insurance_name,
                remark: result.data.remark,

                cs_full_name: result.data.cs_full_name,
                cs_age: result.data.cs_age,
                cs_relation: result.data.cs_relation,
                cs_addess: result.data.cs_addess,
                cs_village: result.data.cs_village,
                cs_street: result.data.cs_street,
                cs_district: result.data.cs_district ? district.map(item => { { return { value: item.district_name, label: item.district_name, province_name: item.province_name } } }).filter(item => item.value === result.data.cs_district)[0] : "",
                cs_sub_district: result.data.cs_sub_district ? subdistrict.map(item => { { return { value: item.sub_district_name, label: item.sub_district_name, district_name: item.district_name } } }).filter(item => item.value === result.data.cs_sub_district)[0] : "",
                cs_province: result.data.cs_province ? province.map(item => { { return { value: item.province_name, label: item.province_name } } }).filter(item => item.value === result.data.cs_province)[0] : "",
                cs_phone: result.data.cs_phone,

                signature_get_car: result.data.signature_get_car,
                signature_repair: result.data.signature_repair,
                signature_witness: result.data.signature_witness,

                litigant_name: result.data.litigant_name,
                other_t1: result.data.other_t1,

                repair_01: result.data.repair_01,
                repair_02: result.data.repair_02,
                repair_03: result.data.repair_03,
                repair_04: result.data.repair_04,
                repair_05: result.data.repair_05,
                repair_06: result.data.repair_06,
                repair_07: result.data.repair_07,
                repair_08: result.data.repair_08,
                repair_09: result.data.repair_09,
                repair_10: result.data.repair_10,
                repair_11: result.data.repair_11,
                repair_12: result.data.repair_12,
                repair_13: result.data.repair_13,
                repair_14: result.data.repair_14,

                oil: result.data.oil,
                tool: result.data.tool,
                spare_tire: result.data.spare_tire,
                air: result.data.air,
                air_text: result.data.air_text,
                other_t3: result.data.other_t3,
                other_t3_text: result.data.other_t3_text,
                driver_license: result.data.driver_license,
                copy_license_plate: result.data.copy_license_plate,
                insurance_policy: result.data.insurance_policy,
                id_card_owner: result.data.id_card_owner,
                copy_certified_company: result.data.copy_certified_company,

                note: result.data.note,
            });
            if (result.data.job_status >= 6) {
                this.setState({ readOnly: true })
            }
            if (quotation_number) {
                setTimeout(() => {
                    this.GetQuotationById(quotation_number.quotation_id)
                }, 10);
            }
        }
        this.setState({ loading: false });
    }
    getProductAll = async () => {
        let body = {
            page: 0,
            data_search: "",
            product_id: ""
        }
        let result = await GET(tokens, "v1/TH/product-manage/product/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("getProductAll:", result);

            this.setState({
                data_product: result.data.map(e => { return { label: e.product_name, value: e.product_id, ...e } }),

            });
        }
    }
    GetAdmin = async () => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            user_id: ""
        }
        let result = await GET(tokens, "v1/TH/user-admin/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetAdmin:", result);
            this.setState({
                data_admin: result.data.filter(e => e.user_type === "technician").map(e => { return { value: e.full_name, label: e.full_name } }),
            });
        }
        this.setState({ loading: false });
    }
    GetMember = async () => {
        let body = {
            page: 0,
            data_search: "",
            member_id: ""
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetMember:", result)
            let data_license_plate = [];
            for (let member of result.data) {
                for (let car_list of member.car_list) {
                    data_license_plate.push({ label: car_list, value: car_list, member_id: member.member_id })
                }
            }
            this.setState({
                data_member: result.data.map(e => { return { value: e.full_name, label: e.full_name, ...e } }),
                data_license_plate: data_license_plate
            });
        }
    }
    GetMemberById = async (id) => {
        let body = {
            page: 0,
            data_search: "",
            member_id: id
        }
        let result = await GET(tokens, "v1/TH/member-info/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetMember:", result)
            console.log("this.state.license_plate:", this.state.license_plate)
            let car = result.data.car_list.filter(e => e.license_plate === this.state.license_plate.value)[0];
            console.log("car:", car)
            this.setState({
                brand_name: car.brand_name,
                model_name: car.model_name,
                address: result.data.address,
                job_status: "1",
                phone_number: result.data.phone_number,
                type: car.car_type_1,
                member_name: this.state.data_member.filter(e => e.member_id === result.data.member_id)[0],
                policy_number: car.insurance_number,
                chassis_number: car.cassi_number,
                machine_number: car.engine_number,
                insurance_name: car.insurance_name
            })
        }
    }
    GetQuotation = async () => {
        let body = {
            page: 0,
            data_search: "",
            quotation_id: "",
            type: "repair"
        }
        let result = await GET(tokens, "v1/TH/quotation/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetQuotation:", result);
            this.setState({ data_quotation: result.data.filter(e => e.quotation_status === 2).map(e => { return { value: e.quotation_number, label: e.quotation_number, quotation_id: e.quotation_id, license_plate: e.license_plate } }) });
        }
    }
    GetQuotationById = async (id) => {
        this.setState({ loading: true });
        let body = {
            page: 0,
            data_search: "",
            quotation_id: id
        }
        let result = await GET(tokens, "v1/TH/quotation/list/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            console.log("GetQuotation:", result);
            this.setState({
                license_plate: result.data.license_plate ? { value: result.data.license_plate, label: result.data.license_plate, member_id: result.data.member_id } : "",
                product_list: result.data.product_list.map(e => {
                    return {
                        product_type: e.product_id ? this.state.data_product.filter(i => i.product_id === e.product_id)[0].product_type : "",
                        product_id: e.product_id ? this.state.data_product.filter(i => i.product_id === e.product_id)[0] : "",
                        qty: Number(e.qty_unit),
                        price: Number(e.price_unit),
                        discount_by_item: Number(e.discount_by_item),
                        estimated_price: Number(e.price_unit)*((100-Number(e.discount_by_item))/100),
                        total_price: Number(e.qty_unit) * Number(e.price_unit)*((100-Number(e.discount_by_item))/100)
                    }
                }),
                claim_number: result.data.claim_number
            });
            setTimeout(() => {
                this.GetMemberById(result.data.member_id)
            }, 10);
        }
        this.setState({ loading: false });
    }
    Create = async () => {
        this.setState({ loading: true });
        let body = {
            goods_issuance_code: this.state.goods_issuance_code,
            quotation_number: this.state.quotation_number ? this.state.quotation_number.value : "",
            brand_name: this.state.brand_name,
            model_name: this.state.model_name,
            member_name: this.state.member_name ? this.state.member_name.value : "",
            address: this.state.address,
            phone_number: this.state.phone_number,
            type: this.state.type,
            repair_date: this.state.repair_date ? format_date(this.state.repair_date, "yyyy-mm-dd", "en") : null,
            complete_date: this.state.complete_date ? format_date(this.state.complete_date, "yyyy-mm-dd", "en") : null,
            due_date: this.state.due_date ? format_date(this.state.due_date, "yyyy-mm-dd", "en") : null,
            technician_name: this.state.technician_name ? this.state.technician_name.value : "",
            claim_number: this.state.claim_number,
            license_plate: this.state.license_plate ? this.state.license_plate.value : "",
            chassis_number: this.state.chassis_number,
            machine_number: this.state.machine_number,
            policy_number: this.state.policy_number,
            total_spare: 0,
            total_repair: 0,
            job_status: Number(this.state.job_status),
            product_list: this.state.product_list.map(item => {
                return {
                    product_id: item.product_id ? item.product_id.value : "",
                    qty: Number(item.qty),
                    price: Number(item.price),
                    discount_by_item: Number(item.discount_by_item),
                    discount: 0,
                    estimated_price: Number(item.estimated_price)
                }
            }),
            payment_type: this.state.payment_type,
            installments: this.state.installments,
            remark: this.state.remark,

            picture_list_bf: this.state.picture_list_bf,
            picture_list_af: this.state.picture_list_af,

            cs_full_name: this.state.cs_full_name,
            cs_age: Number(this.state.cs_age),
            cs_relation: this.state.cs_relation,
            cs_addess: this.state.cs_addess,
            cs_village: this.state.cs_village,
            cs_street: this.state.cs_street,
            cs_district: this.state.cs_district ? this.state.cs_district.value : "",
            cs_sub_district: this.state.cs_sub_district ? this.state.cs_sub_district.value : "",
            cs_province: this.state.cs_province ? this.state.cs_province.value : "",
            cs_phone: this.state.cs_phone,

            signature_get_car: this.state.signature_get_car,
            signature_repair: this.state.signature_repair,
            signature_witness: this.state.signature_witness,

            litigant_name: this.state.litigant_name,
            other_t1: this.state.other_t1,

            repair_01: this.state.repair_01,
            repair_02: this.state.repair_02,
            repair_03: this.state.repair_03,
            repair_04: this.state.repair_04,
            repair_05: this.state.repair_05,
            repair_06: this.state.repair_06,
            repair_07: this.state.repair_07,
            repair_08: this.state.repair_08,
            repair_09: this.state.repair_09,
            repair_10: this.state.repair_10,
            repair_11: this.state.repair_11,
            repair_12: this.state.repair_12,
            repair_13: this.state.repair_13,
            repair_14: this.state.repair_14,

            oil: this.state.oil,
            tool: this.state.tool,
            spare_tire: this.state.spare_tire,
            air: this.state.air,
            air_text: this.state.air_text,
            other_t3: this.state.other_t3,
            other_t3_text: this.state.other_t3_text,
            driver_license: this.state.driver_license,
            copy_license_plate: this.state.copy_license_plate,
            insurance_policy: this.state.insurance_policy,
            id_card_owner: this.state.id_card_owner,
            copy_certified_company: this.state.copy_certified_company,
            note: this.state.note,

            discount:0

        }
        console.log("BODY:", body)
        let result = await POST(tokens, "v1/TH/job-repair/create/" + getStorage("branch").branch_id, body);
        if (result && result.status) {
            success_url("/manage-repair/list-repair");
        }
        this.setState({ loading: false });
    }
    Update = async () => {
        this.setState({ loading: true });
        let body = {
            job_id: this.state.job_id,
            goods_issuance_code: this.state.goods_issuance_code,
            quotation_number: this.state.quotation_number ? this.state.quotation_number.value : "",
            brand_name: this.state.brand_name,
            model_name: this.state.model_name,
            member_name: this.state.member_name ? this.state.member_name.value : "",
            address: this.state.address,
            phone_number: this.state.phone_number,
            type: this.state.type,
            repair_date: this.state.repair_date ? format_date(this.state.repair_date, "yyyy-mm-dd", "en") : null,
            complete_date: this.state.complete_date ? format_date(this.state.complete_date, "yyyy-mm-dd", "en") : null,
            due_date: this.state.due_date ? format_date(this.state.due_date, "yyyy-mm-dd", "en") : null,
            technician_name: this.state.technician_name ? this.state.technician_name.value : "",
            claim_number: this.state.claim_number,
            license_plate: this.state.license_plate ? this.state.license_plate.value : "",
            chassis_number: this.state.chassis_number,
            machine_number: this.state.machine_number,
            policy_number: this.state.policy_number,
            total_spare: 0,
            total_repair: 0,
            job_status: Number(this.state.job_status),
            product_list: this.state.product_list.map(item => {
                return {
                    cjd_id: item.cjd_id ? item.cjd_id : "",
                    product_id: item.product_id ? item.product_id.value : "",
                    qty: Number(item.qty),
                    price: Number(item.price),
                    discount_by_item: Number(item.discount_by_item),
                    discount: 0,
                    estimated_price: Number(item.estimated_price)
                }
            }),
            picture_list: [],
            payment_type: this.state.payment_type,
            installments: this.state.installments,
            remark: this.state.remark,

            picture_list_bf: this.state.picture_list_bf,
            picture_list_af: this.state.picture_list_af,

            cs_full_name: this.state.cs_full_name,
            cs_age: Number(this.state.cs_age),
            cs_relation: this.state.cs_relation,
            cs_addess: this.state.cs_addess,
            cs_village: this.state.cs_village,
            cs_street: this.state.cs_street,
            cs_district: this.state.cs_district ? this.state.cs_district.value : "",
            cs_sub_district: this.state.cs_sub_district ? this.state.cs_sub_district.value : "",
            cs_province: this.state.cs_province ? this.state.cs_province.value : "",
            cs_phone: this.state.cs_phone,

            signature_get_car: this.state.signature_get_car,
            signature_repair: this.state.signature_repair,
            signature_witness: this.state.signature_witness,

            litigant_name: this.state.litigant_name,
            other_t1: this.state.other_t1,

            repair_01: this.state.repair_01,
            repair_02: this.state.repair_02,
            repair_03: this.state.repair_03,
            repair_04: this.state.repair_04,
            repair_05: this.state.repair_05,
            repair_06: this.state.repair_06,
            repair_07: this.state.repair_07,
            repair_08: this.state.repair_08,
            repair_09: this.state.repair_09,
            repair_10: this.state.repair_10,
            repair_11: this.state.repair_11,
            repair_12: this.state.repair_12,
            repair_13: this.state.repair_13,
            repair_14: this.state.repair_14,

            oil: this.state.oil,
            tool: this.state.tool,
            spare_tire: this.state.spare_tire,
            air: this.state.air,
            air_text: this.state.air_text,
            other_t3: this.state.other_t3,
            other_t3_text: this.state.other_t3_text,
            driver_license: this.state.driver_license,
            copy_license_plate: this.state.copy_license_plate,
            insurance_policy: this.state.insurance_policy,
            id_card_owner: this.state.id_card_owner,
            copy_certified_company: this.state.copy_certified_company,
            note: this.state.note,

            discount:0
        }
        let result = await PUT(tokens, "v1/TH/job-repair/update", body);
        if (result && result.status) {
            success_url("/manage-repair/repair/create");
        }
        this.setState({ loading: false });
    }
    import_file = (e, type) => {
        if (this.state.picture_list_bf.length + e.target.files.length > 10 && type === "bf") {
            alert("warning", "แจ้งเตือน", "สามารถอัพโหลดรูปได้สูงสุด 10 รูป");
            return;
        } if (this.state.picture_list_af.length + e.target.files.length > 10 && type === "at") {
            alert("warning", "แจ้งเตือน", "สามารถอัพโหลดรูปได้สูงสุด 10 รูป");
            return;
        }
        if (e.target.files.length === 1) {
            this.changePhoto(e.target.files[0], type);
            if (type === "bf") {
                document.getElementById("file_bf").value = "";
                document.getElementById("file_bf").file = null;
            }
            if (type === "at") {
                document.getElementById("file_at").value = "";
                document.getElementById("file_at").file = null;
            }
        } else {
            this.multiple_file(0, e.target.files.length, e.target.files, type);
        }
    }
    multiple_file = async (index, max, file, type) => {
        await this.changePhoto(file[index], type);
        if (index + 1 < max) {
            setTimeout(() => {
                this.multiple_file(index + 1, max, file, type);
            }, 10);
        } else {
            document.getElementById("file_bf").value = "";
            document.getElementById("file_bf").file = null;
            document.getElementById("file_at").value = "";
            document.getElementById("file_at").file = null;
        }
    }
    changePhoto = async (file, type) => {
         
        if (!file.type.includes("image")) {
            alert("error", "แจ้งเตือน", "ไม่สามารถอัพโหลดไฟล์ได้เนื่องจากไม่รองรับรูปแบบไฟล์");
            return
        }
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (e) => { }
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 512, 512, "JPG", 100, 0,
                (uri) => {
                    if (type === "bf") {
                        let picture_list_bf = this.state.picture_list_bf;
                        picture_list_bf.push(uri.split(",")[1]);
                        this.setState({ picture_list_bf: picture_list_bf });
                    } else if (type === "at") {
                        let picture_list_af = this.state.picture_list_af;
                        picture_list_af.push(uri.split(",")[1]);
                        this.setState({ picture_list_af: picture_list_af });
                    }
                },
                "base64"
            );
        });
    }
    delete_image = (index, type) => {
        if (type === "bf") {
            let picture_list_bf = this.state.picture_list_bf;
            picture_list_bf.splice(index, 1);
            this.setState({ picture_list_bf: picture_list_bf });
        } else if (type === "at") {
            let picture_list_af = this.state.picture_list_af;
            picture_list_af.splice(index, 1);
            this.setState({ picture_list_af: picture_list_af });
        }
    }

    trim = () => {
        if (this.state.type_signature === "signature_get_car") {
            this.setState({ signature_get_car: this.sigPad.getTrimmedCanvas().toDataURL('image/png').split(",")[1] })
        } else if (this.state.type_signature === "signature_repair") {
            this.setState({ signature_repair: this.sigPad.getTrimmedCanvas().toDataURL('image/png').split(",")[1] })
        } else if (this.state.type_signature === "signature_witness") {
            this.setState({ signature_witness: this.sigPad.getTrimmedCanvas().toDataURL('image/png').split(",")[1] })
        }
        setTimeout(() => {
            this.onSendCar();
        }, 10);

    }
    onSendCar = () => {
        if (this.state.cs_full_name !== "" ||
            this.state.cs_age !== "" ||
            this.state.cs_relation !== "" ||
            this.state.cs_addess !== "" ||
            this.state.cs_village !== "" ||
            this.state.cs_street !== "" ||
            this.state.cs_district !== "" ||
            this.state.cs_sub_district !== "" ||
            this.state.cs_province !== "" ||
            this.state.cs_phone !== "" ||
            this.state.signature_get_car !== "" ||
            this.state.signature_repair !== "" ||
            this.state.signature_witness !== "") {
            this.setState({ job_status: "5", check: true })
        } else {
            this.setState({ check: false })
        }
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการงานซ่อม" page3="แจ้งซ่อม"/>
                {/* BODY */}
                <div className="body bg-light min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test">
                            <h3 className="mb-2"><b>แจ้งซ่อม</b></h3>
                        </div>
                        <div className="card w-100 bg-white border-0 p-3 mb-2">
                            <div className="row">
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">JOB ID: ค้นหา</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_job}
                                        onChange={(e) => {
                                            this.setState({ job_number: e, });
                                            if (e) {
                                                this.setState({ job_id: e.value })
                                                setTimeout(() => {
                                                    this.GetById(e.value);
                                                }, 10);
                                            } else {
                                                this.setState({ job_id: "" })
                                            }
                                        }}
                                        value={this.state.job_number}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-6 col-md-4 col-lg-2 mb-2">
                                    <label className="mb-2">วันที่:</label>
                                    <DatePicker
                                        className="form-control mb-2"
                                        placeholder="พิมพ์คำค้นหา..."
                                        value={new Date()}
                                        disabled
                                    />
                                </div>
                                <div className="col-12 d-md-none col-lg-2"></div>
                                <div className="col-6 col-md-4 col-lg-2 mb-2">
                                    <div className="bg-primary rounded p-1">
                                        <label className="mb-2 text-white">สถานะงาน:</label>
                                        <select
                                            className="form-control"
                                            placeholder=""
                                            onChange={(e) => {
                                                this.setState({
                                                    job_status: e.target.value,
                                                    cs_full_name: this.state.cs_full_name,
                                                    cs_age: Number(this.state.cs_age),
                                                    cs_relation: this.state.cs_relation,
                                                    cs_addess: this.state.cs_addess,
                                                    cs_village: this.state.cs_village,
                                                    cs_street: this.state.cs_street,
                                                    cs_district: this.state.cs_district ? this.state.cs_district.value : "",
                                                    cs_sub_district: this.state.cs_sub_district ? this.state.cs_sub_district.value : "",
                                                    cs_province: this.state.cs_province ? this.state.cs_province.value : "",
                                                    cs_phone: this.state.cs_phone,

                                                    signature_get_car: this.state.signature_get_car,
                                                    signature_repair: this.state.signature_repair,
                                                    signature_witness: this.state.signature_witness,
                                                })
                                            }}
                                            value={this.state.job_status}
                                            disabled={this.state.readOnly || this.state.check}
                                        >
                                            <option value="1">นัดเข้าซ่อม</option>
                                            <option value="2">รับรถเข้าซ่อม</option>
                                            <option value="3">สั่งอะไหล่</option>
                                            <option value="4">กำลังซ่อม</option>
                                            <option value="5">ซ่อมสำเร็จ</option>
                                            <option value="6">ส่งมอบ</option>
                                            <option value="7" hidden>ปิดงาน</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <hr className="my-1" />
                            <div className="row">
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">ชื่อลูกค้า:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_member}
                                        onChange={(e) => {
                                            this.setState({ member_name: e })
                                            if (e) {
                                                this.setState({
                                                    phone_number: e.phone_number,
                                                    license_plate: "",
                                                    brand_name: "",
                                                    model_name: "",
                                                    address: "",
                                                    type: "",
                                                    policy_number: "",
                                                    chassis_number: "",
                                                    machine_number: ""
                                                });
                                            }
                                        }}
                                        value={this.state.member_name}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">ทะเบียนรถ:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_license_plate.filter(e => !this.state.member_name || e.member_id === this.state.member_name.member_id)}
                                        onChange={(e) => {
                                            this.setState({ license_plate: e });
                                            if (e) {
                                                setTimeout(() => {
                                                    this.GetMemberById(e.member_id);
                                                }, 10);
                                            }
                                        }}
                                        value={this.state.license_plate}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">โทรศัพท์:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        maxLength={10}
                                        onChange={(e) => {
                                            if (!float(e.target.value)) {
                                                return
                                            }
                                            this.setState({ phone_number: e.target.value })
                                        }}
                                        value={this.state.phone_number}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">ประเภท:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        maxLength={10}
                                        value={this.state.type}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">เลขตัวถัง:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ chassis_number: e.target.value }) }}
                                        value={this.state.chassis_number}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">เลขเครื่องยนต์:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ machine_number: e.target.value }) }}
                                        value={this.state.machine_number}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">เลขกรมธรรม์:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ policy_number: e.target.value }) }}
                                        value={this.state.policy_number}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">ยี่ห้อ:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ brand_name: e.target.value }) }}
                                        value={this.state.brand_name}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="mb-2">รุ่น:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ model_name: e.target.value }) }}
                                        value={this.state.model_name}
                                        readOnly
                                    />
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 mb-2">
                                    <label className="wpx-110">ประกันบริษัท :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ insurance_name: e.target.value }) }}
                                        value={this.state.insurance_name}
                                        readOnly
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-4 mb-2">
                                    <label className="wpx-110">หมายเหตุ :</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ remark: e.target.value }) }}
                                        value={this.state.remark}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                            </div>
                            <hr className="my-1" />
                            <div className="row">
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">อ้างอิงใบเสนอราคา: </label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_quotation.filter(e => !this.state.license_plate || e.license_plate === this.state.license_plate.value)}
                                        onChange={(e) => {
                                            this.setState({ quotation_number: e });
                                            if (e) {
                                                setTimeout(() => {
                                                    this.GetQuotationById(e.quotation_id)
                                                }, 10);
                                            }
                                        }}
                                        value={this.state.quotation_number}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">เลขใบเคลม:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ claim_number: e.target.value }) }}
                                        value={this.state.claim_number}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-6 col-md-4 mb-2">
                                    <label className="mb-2">เลขใบเบิกสินค้า:</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder=""
                                        onChange={(e) => { this.setState({ goods_issuance_code: e.target.value }) }}
                                        value={this.state.goods_issuance_code}
                                        disabled
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">นัดวันแจ้งซ่อม:</label>
                                    <DatePicker
                                        className="form-control mb-2"
                                        placeholder="พิมพ์คำค้นหา..."
                                        onChange={(e) => {
                                            this.setState({ repair_date: e });
                                        }}
                                        value={this.state.repair_date}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">วันที่เสร็จ:</label>
                                    <DatePicker
                                        className="form-control mb-2"
                                        placeholder="พิมพ์คำค้นหา..."
                                        onChange={(e) => {
                                            this.setState({ complete_date: e });
                                        }}
                                        value={this.state.complete_date}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">วันครบกำหนดชำระ:</label>
                                    <DatePicker
                                        className="form-control mb-2"
                                        placeholder="พิมพ์คำค้นหา..."
                                        onChange={(e) => {
                                            this.setState({ due_date: e });
                                        }}
                                        value={this.state.due_date}
                                        disabled={this.state.readOnly}
                                    />
                                </div>
                                <div className="col-6 col-md-3 mb-2">
                                    <label className="mb-2">ช่างผู้รับงาน:</label>
                                    <Select
                                        className="form-control select-search"
                                        styles={select_style}
                                        options={this.state.data_admin}
                                        onChange={(e) => {
                                            this.setState({ technician_name: e });
                                        }}
                                        value={this.state.technician_name}
                                        isClearable
                                        isDisabled={this.state.readOnly}
                                    ></Select>
                                </div>
                            </div>
                        </div>
                        <div className="card w-100 bg-white border-0 p-3">
                            <div className="row mx-0">
                                <div className="col-6 col-md-3 col-lg-2 px-0">
                                    <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 1 ? " border-primary bg-light" : " border-white bg-white")}
                                        onClick={() => { this.setState({ tab: 1 }) }}>
                                        <span className="icon me-2">{"\uf51e"}</span> ประเมินค่าใช้จ่าย
                                    </div>
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 px-0">
                                    <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 2 ? " border-primary bg-light" : " border-white bg-white")}
                                        onClick={() => { this.setState({ tab: 2 }) }}>
                                        <span className="icon me-2">{"\uf03e"}</span> รูปถ่ายรถ
                                    </div>
                                </div>
                                <div className="col-6 col-md-3 col-lg-2 px-0">
                                    <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 3 ? " border-primary bg-light" : " border-white bg-white")}
                                        onClick={() => { this.setState({ tab: 3 }) }}>
                                        <span className="icon me-2">{"\uf03e"}</span> ข้อมูลรับรถ
                                    </div>
                                </div>
                                {Number(this.state.job_status) >= 5 && (
                                    <div className="col-6 col-md-3 col-lg-2 px-0">
                                        <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 4 ? " border-primary bg-light" : " border-white bg-white")}
                                            onClick={() => { this.setState({ tab: 4 }) }}>
                                            <span className="icon me-2">{"\uf03e"}</span> ข้อมูลส่งรถ
                                        </div>
                                    </div>
                                )}
                                {this.state.job_id && (
                                    <div className="col-6 col-md-3 col-lg-2 px-0">
                                        <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 5 ? " border-primary bg-light" : " border-white bg-white")}
                                            onClick={() => { this.setState({ tab: 5 }) }}>
                                            <span className="icon me-2">{"\uf0ad"}</span> ประวัติการซ่อม
                                        </div>
                                    </div>
                                )}
                                {this.state.job_id && (
                                    <div className="col-6 col-md-3 col-lg-2 px-0">
                                        <div className={"pointer w-100 p-3 border-3 border-top text-center text-primary" + (this.state.tab === 6 ? " border-primary bg-light" : " border-white bg-white")}
                                            onClick={() => { this.setState({ tab: 6 }) }}>
                                            <span className="icon me-2">{"\uf02f"}</span> พิมพ์เอกสาร
                                        </div>
                                    </div>
                                )}
                            </div>
                            <hr className="mt-0" />
                            <div className="row">
                                {this.state.tab === 1 && (
                                    <div className="col-12">
                                        <div>
                                            <table className="table table-borderless table-striped">
                                                <thead className="bg-primary">
                                                    <tr>
                                                        <th className="text-center text-white">ประเภท</th>
                                                        <th className="text-center text-white">รายการ</th>
                                                        <th className="text-center text-white wpx-70">จำนวน</th>
                                                        <th className="text-end text-white wpx-100">ราคา</th>
                                                        <th className="text-center text-white wpx-100">ส่วนลด %</th>
                                                        <th className="text-center text-white wpx-100">ราคาประเมิน</th>
                                                        <th className="text-end text-white wpx-80">ราคารวม</th>
                                                        <th className="text-center text-white wpx-70">จัดการ</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.product_list && this.state.product_list.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">
                                                                <select className="form-control"
                                                                    onChange={(e) => {
                                                                        let product_list = this.state.product_list;
                                                                        product_list[index].product_type = e.target.value;
                                                                        product_list[index].product_id = "";
                                                                        product_list[index].qty = "";
                                                                        product_list[index].price = "";
                                                                        product_list[index].discount_by_item = "";
                                                                        product_list[index].estimated_price = "";
                                                                        product_list[index].total_price = "";
                                                                        this.setState({
                                                                            product_list: product_list
                                                                        })
                                                                    }}
                                                                    value={item.product_type}
                                                                    disabled={this.state.readOnly}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="อะไหล่">อะไหล่</option>
                                                                    <option value="การซ่อม">การซ่อม</option>
                                                                </select>
                                                            </td>
                                                            <td> <Select
                                                                className="form-control select-search text-start"
                                                                styles={select_style}
                                                                options={this.state.data_product.filter(e => !item.product_type || e.product_type === item.product_type)}
                                                                onChange={(e) => {
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].product_id = e;
                                                                    if (e) {
                                                                        product_list[index].price = e.sell_priceว
                                                                        if (e.product_type === "การซ่อม") {
                                                                            product_list[index].qty = 1;
                                                                        }
                                                                    }
                                                                    product_list[index].total_price = Number(product_list[index].estimated_price) * Number(product_list[index].qty);
                                                                    this.setState({ product_list: product_list })
                                                                }}
                                                                value={item.product_id}
                                                                isClearable
                                                                isDisabled={this.state.readOnly}
                                                            ></Select></td>
                                                            <td className="text-center">
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        let product_list = this.state.product_list;
                                                                        product_list[index].qty = e.target.value; 
                                                                        product_list[index].total_price = (Number(product_list[index].estimated_price) * Number(product_list[index].qty))*((100-Number(item.discount_by_item))/100);
                                                                        this.setState({ product_list: product_list })
                                                                    }}
                                                                    value={item.qty}
                                                                    disabled={(item.product_id && item.product_id.product_type === "การซ่อม") || this.state.readOnly}
                                                                />
                                                            </td>
                                                            <td className="text-end">
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        let product_list = this.state.product_list;
                                                                        product_list[index].price = e.target.value;
                                                                        this.setState({ product_list: product_list })
                                                                    }}
                                                                    value={item.price}
                                                                    disabled={this.state.readOnly}
                                                                /></td>
                                                            <td className="text-center">
                                                                <select className="form-control"
                                                                onChange={(e)=>{
                                                                    let product_list = this.state.product_list;
                                                                    product_list[index].discount_by_item = e.target.value;
                                                                    product_list[index].total_price = (Number(product_list[index].estimated_price) * Number(product_list[index].qty))*((100-Number(item.discount_by_item))/100);
                                                                    this.setState({ product_list: product_list })
                                                                    
                                                                }}
                                                                value={item.discount_by_item}
                                                                >
                                                                    <option></option>
                                                                    <option value="5">5 %</option>
                                                                    <option value="10">10 %</option>
                                                                </select>
                                                                </td>
                                                            <td className="text-center">
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        let product_list = this.state.product_list;
                                                                        product_list[index].estimated_price = e.target.value;
                                                                        product_list[index].total_price = (Number(product_list[index].estimated_price) * Number(product_list[index].qty))*((100-Number(item.discount_by_item))/100);
                                                                        this.setState({ product_list: product_list })
                                                                    }}
                                                                    value={item.estimated_price}
                                                                    disabled={this.state.readOnly}
                                                                />
                                                            </td>
                                                            <td className="text-end">{item.total_price ? toFixed(item.total_price) : "0.00"}</td>
                                                            <td className="text-center">
                                                                {!this.state.readOnly && (
                                                                    <div className="mx-auto icon wpx-30 hpx-30 text-18 text-secondary d-flex justify-content-center align-items-center pointer"
                                                                        onClick={() => {
                                                                            let product_list = this.state.product_list;
                                                                            product_list.splice(index, 1);
                                                                            this.setState({ product_list: product_list });
                                                                        }}>{"\uf2ed"}</div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    {!this.state.readOnly && (
                                                        <tr>
                                                            <td className="text-center wpx-120">
                                                                <select className="form-control"
                                                                    onChange={(e) => {
                                                                        this.setState({
                                                                            product_type: e.target.value,
                                                                            product_id: "",
                                                                            qty: "",
                                                                            price: "",
                                                                            discount_by_item: "",
                                                                            estimated_price: ""
                                                                        })
                                                                    }}
                                                                    value={this.state.product_type}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="อะไหล่">อะไหล่</option>
                                                                    <option value="การซ่อม">การซ่อม</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <Select
                                                                    className="form-control select-search text-start"
                                                                    styles={select_style}
                                                                    options={this.state.data_product.filter(e => !this.state.product_type || e.product_type === this.state.product_type)}
                                                                    onChange={(e) => {
                                                                        this.setState({ product_id: e });
                                                                        if (e) {
                                                                            this.setState({ price: e.sell_price });
                                                                            if (e.product_type === "การซ่อม") {
                                                                                this.setState({ qty: 1 });
                                                                            }
                                                                        }
                                                                    }}
                                                                    value={this.state.product_id}
                                                                    isClearable
                                                                    isDisabled={this.state.readOnly}
                                                                ></Select>
                                                            </td>
                                                            <td className="text-center">
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        this.setState({ qty: Number(e.target.value) })
                                                                    }}
                                                                    value={this.state.qty}
                                                                    disabled={(this.state.product_id && this.state.product_id.product_type === "การซ่อม") || this.state.readOnly}
                                                                />
                                                            </td>
                                                            <td className="text-end">
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        this.setState({ price: e.target.value })
                                                                    }}
                                                                    value={this.state.price}
                                                                    disabled={this.state.readOnly}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                <select className="form-control"
                                                                onChange={(e)=>{ 
                                                                    this.setState({ discount_by_item: e.target.value }) 
                                                                }}
                                                                value={this.state.discount_by_item}
                                                                >
                                                                    <option value=""></option>
                                                                    <option value="5">5 %</option>
                                                                    <option value="10">10 %</option>
                                                                </select>
                                                                </td>
                                                            <td className="text-center">
                                                                <input
                                                                    className="form-control text-end"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        this.setState({ estimated_price: e.target.value })
                                                                    }}
                                                                    value={this.state.estimated_price}
                                                                    disabled={this.state.readOnly}
                                                                />
                                                            </td>
                                                            <td className="text-end">

                                                                <label>{toFixed((Number(this.state.qty) * Number(this.state.estimated_price))*((100-Number(this.state.discount_by_item))/100))}</label>

                                                            </td>
                                                            <td className="text-center">
                                                                <div className="mx-auto wpx-30 hpx-30 rounded-circle bg-blue text-24 text-white d-flex justify-content-center align-items-center pointer"
                                                                    onClick={() => {
                                                                        if (!this.state.product_id) {
                                                                            alert("warning", "แจ้งเตือน", "กรุณาเลือกสินค้า");
                                                                            return;
                                                                        } else if (!this.state.qty) {
                                                                            alert("warning", "แจ้งเตือน", "กรุณากรอกจำนวน");
                                                                            return;
                                                                        } else if (!this.state.estimated_price) {
                                                                            alert("warning", "แจ้งเตือน", "กรุณากรอกราคาประเมิน");
                                                                            return;
                                                                        }
                                                                        let product_list = this.state.product_list;

                                                                        product_list.push({
                                                                            product_type: this.state.product_type,
                                                                            product_id: this.state.product_id,
                                                                            qty: Number(this.state.qty),
                                                                            price: Number(this.state.price),
                                                                            discount_by_item: this.state.discount_by_item,
                                                                            estimated_price: Number(this.state.estimated_price),
                                                                            total_price: (Number(this.state.qty) * Number(this.state.estimated_price))*((100-Number(this.state.discount_by_item))/100)
                                                                        });
                                                                        this.setState({
                                                                            product_list: product_list,
                                                                            product_type: "",
                                                                            product_id: "",
                                                                            qty: "",
                                                                            price: "",
                                                                            discount_by_item: "",
                                                                            estimated_price: "",
                                                                        });
                                                                    }}>+</div>
                                                            </td>
                                                        </tr>)}
                                                </tbody>
                                            </table>
                                            <div className="d-flex align-items-center justify-content-end">
                                                <label>รวมเป็นเงิน</label>
                                                <h3 className="wpx-200 text-end"><b>{toFixed(total(this.state.product_list, "total_price"))}</b></h3>
                                            </div>
                                        </div>

                                        <div className="p-3 pb-0">
                                            <div className="row">
                                                <div className="col-12 col-lg-6 mb-2">
                                                    <label className="wpx-110">โน้ต :</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={5}
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ note: e.target.value }) }}
                                                        value={this.state.note}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                                <div className="col-12 col-lg-6 mb-2">
                                                    <div className="py-3">
                                                        <div className="card bg-primary border-0 rounded-lg mb-2 text-white">
                                                            <div className="d-flex flex-wrap align-items-center p-2">
                                                                <input
                                                                    className="mx-1 mb-2"
                                                                    type="radio"
                                                                    name="type"
                                                                    placeholder=""
                                                                    onChange={(e) => { this.setState({ payment_type: 1, installments_count: "", installments: [] }) }}
                                                                    checked={this.state.payment_type === 1}
                                                                    disabled={this.state.readOnly}
                                                                />
                                                                <label className="mx-1 wpx-100 mb-2">ชำระทั้งหมด</label>
                                                                <input
                                                                    className="mx-1 mb-2"
                                                                    type="radio"
                                                                    name="type"
                                                                    placeholder=""
                                                                    onChange={(e) => { this.setState({ payment_type: 2, installments_count: "", installments: [] }) }}
                                                                    checked={this.state.payment_type === 2}
                                                                    disabled={this.state.readOnly}
                                                                />
                                                                <label className="mx-1 wpx-70 mb-2">แบ่งชำระ</label>
                                                                <input
                                                                    className="form-control border-0 mx-1 wpx-100 mb-2"
                                                                    type="text"
                                                                    placeholder=""
                                                                    onChange={(e) => {
                                                                        if (!float(e.target.value)) {
                                                                            return
                                                                        }
                                                                        let installments = [];
                                                                        for (let i = 0; i < Number(e.target.value); i++) {
                                                                            installments.push({ price: "", status: false });
                                                                        }
                                                                        this.setState({ installments_count: Number(e.target.value), installments: installments })
                                                                    }}
                                                                    value={this.state.installments_count}
                                                                    readOnly={this.state.payment_type === 1 || this.state.readOnly}
                                                                />
                                                                <label className="mx-1 wpx-40 mb-2">งวด</label>
                                                                {this.state.payment_type === 2 && (
                                                                    <label className="d-flex align-items-center mb-2"> ราคารวม : <h4 className="px-2">{toFixed(total(this.state.installments, "price"))}</h4> บาท</label>
                                                                )}
                                                                {this.state.payment_type === 2 && this.state.installments.length !== 0 &&
                                                                    !this.state.readOnly && (
                                                                        <button
                                                                            className="btn btn-light mx-2 px-2 hpx-20 mb-2"
                                                                            onClick={() => {
                                                                                let price = total(this.state.product_list, "total_price");
                                                                                let double = 0.00;
                                                                                let installments = this.state.installments;
                                                                                if (!toFixed(price).includes(".00")) {
                                                                                    double = Number("0." + toFixed(price).split(".")[1]);
                                                                                    price = Number(toFixed(price).split(".")[0].replaceAll(",", ""));
                                                                                }
                                                                                if (price % installments.length !== 0) {
                                                                                    double += price % installments.length;
                                                                                    price -= price % installments.length;
                                                                                }
                                                                                installments = installments.map((item, index) => { return (index === (installments.length - 1)) ? { price: (price / installments.length) + double, status: false } : { price: price / installments.length, status: false } })
                                                                                this.setState({ installments: installments })

                                                                            }}>
                                                                            ราคาเท่ากันทุกงวด
                                                                        </button>
                                                                    )}
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            {this.state.installments.map((item, index) => (
                                                                <div className="col-12 col-md-3">
                                                                    <label className="mb-2">งวดที่: {index + 1}</label>
                                                                    <input
                                                                        className="form-control mb-2"
                                                                        type="text"
                                                                        placeholder=""
                                                                        onChange={(e) => {
                                                                            if (!float(e.target.value)) {
                                                                                return
                                                                            }
                                                                            let installments = this.state.installments;
                                                                            installments[index].price = e.target.value;
                                                                            this.setState({ installments: installments })
                                                                        }}
                                                                        value={item.price}
                                                                        disabled={this.state.readOnly}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>)}
                                {this.state.tab === 2 && (
                                    <div className="col-12">
                                        <input className="d-none" type="file" id="file_bf" accept="image/*" onChange={(e) => { this.import_file(e, "bf") }} multiple />

                                        <b className="text-primary">รูปก่อนซ่อม</b>
                                        <div className="row mt-2 mx-0 mb-2">
                                            {this.state.picture_list_bf.map((item, index) => (
                                                <div className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 border-primary d-flex align-items-center justify-content-center bg-light mb-2">
                                                    <div className="position-relative wpx-150 hpx-150 d-flex justify-content-center align-items-center">
                                                        <img alt="รูปโปรไฟล์" src={item.includes("https://") ? item : "data:image/png;base64," + item} className="wpx-140 hpx-140 overflow-hidden" style={{ objectFit: "contain" }}></img>
                                                        {!this.state.readOnly && (
                                                            <div className="icon bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.delete_image(index, "bf") }}>
                                                                {"\uf00d"}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            {this.state.picture_list_bf.length < 10 && !this.state.readOnly && (
                                                <div
                                                    className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 d-flex align-items-center justify-content-center bg-light"
                                                    onClick={() => { document.getElementById("file_bf").click() }}
                                                >
                                                    <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                    <label className="text-secondary pointer">อัปโหลด</label>
                                                </div>
                                            )}
                                        </div>
                                        <input className="d-none" type="file" id="file_at" accept="image/*" onChange={(e) => { this.import_file(e, "at") }} multiple />
                                        <b className="text-primary">รูปหลังซ่อม</b>
                                        <div className="row mt-2 mx-0">
                                            {this.state.picture_list_af.map((item, index) => (
                                                <div className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 border-primary d-flex align-items-center justify-content-center bg-light mb-2">
                                                    <div className="position-relative wpx-150 hpx-150 d-flex justify-content-center align-items-center">
                                                        <img alt="รูปโปรไฟล์" src={item.includes("https://") ? item : "data:image/png;base64," + item} className="wpx-140 hpx-140 overflow-hidden" style={{ objectFit: "contain" }}></img>
                                                        {!this.state.readOnly && (
                                                            <div className="icon bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.delete_image(index, "at") }}>
                                                                {"\uf00d"}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                            {this.state.picture_list_af.length < 10 && !this.state.readOnly && (
                                                <div
                                                    className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 d-flex align-items-center justify-content-center bg-light"
                                                    onClick={() => { document.getElementById("file_at").click() }}
                                                >
                                                    <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                    <label className="text-secondary pointer">อัปโหลด</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>)}
                                {this.state.tab === 3 && (
                                    <div className="col-12">
                                        {/* รายละเอียด */}
                                        <b className="text-primary">รายละเอียด</b>
                                        <div className="row my-3">
                                            <div className="col-6 col-lg-4 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-110">คู่กรณี บริษัท :</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ litigant_name: e.target.value }) }}
                                                        value={this.state.litigant_name}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 col-lg-4 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-60">อื่นๆ :</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ other_t1: e.target.value }) }}
                                                        value={this.state.other_t1}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* รายการซ่อม */}
                                        <b className="text-primary">รายการซ่อม</b>
                                        <div className="row my-3">
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">1. แก้มหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_01: e.target.value }) }}
                                                        value={this.state.repair_01}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">2. ประตูหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_02: e.target.value }) }}
                                                        value={this.state.repair_02}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">แคบหลัง L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_03: e.target.value }) }}
                                                        value={this.state.repair_03}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">หลังคาเก๋ง</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_04: e.target.value }) }}
                                                        value={this.state.repair_04}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">3. แผงหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_05: e.target.value }) }}
                                                        value={this.state.repair_05}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">4. กันชนหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_06: e.target.value }) }}
                                                        value={this.state.repair_06}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">5. ไฟในกันชนหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_07: e.target.value }) }}
                                                        value={this.state.repair_07}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">6. ไฟใหญ่หน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_08: e.target.value }) }}
                                                        value={this.state.repair_08}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">7. ไฟเลี้ยวหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_09: e.target.value }) }}
                                                        value={this.state.repair_09}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">8. บังโคลนหน้า L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_10: e.target.value }) }}
                                                        value={this.state.repair_10}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">9. เบ้าบันไดบน+ล่าง L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_11: e.target.value }) }}
                                                        value={this.state.repair_11}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">10. กระบะหลัง L + R</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_12: e.target.value }) }}
                                                        value={this.state.repair_12}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">11. แผงตั้งหน้า</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_13: e.target.value }) }}
                                                        value={this.state.repair_13}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">
                                                <div className="d-flex align-items-center">
                                                    <label className="wpx-150">12. แผงหลัง</label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ repair_14: e.target.value }) }}
                                                        value={this.state.repair_14}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* รายการของติดรถ */}
                                        {/* เอกสารที่ท่านต้องนำมาในวันรับรถ */}
                                        <div className="row my-3">
                                            <div className="col-6 mb-2">
                                                <b className="text-primary">รายการของติดรถ</b>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ oil: e.target.checked }) }}
                                                        checked={this.state.oil}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">น้ำมัน</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ tool: e.target.checked }) }}
                                                        checked={this.state.tool}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">เคร่ืองมือ</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ spare_tire: e.target.checked }) }}
                                                        checked={this.state.spare_tire}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">ยางอะไหล่</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ air: e.target.checked }) }}
                                                        checked={this.state.air}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2 wpx-100">แอร์รถยนต์</label>
                                                    <input
                                                        className="form-control me-2"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ air_text: e.target.value }) }}
                                                        value={this.state.air_text}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ other_t3: e.target.checked }) }}
                                                        checked={this.state.other_t3}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2 wpx-100">อื่นๆ</label>
                                                    <input
                                                        className="form-control me-2"
                                                        type="text"
                                                        placeholder=""
                                                        onChange={(e) => { this.setState({ other_t3_text: e.target.value }) }}
                                                        value={this.state.other_t3_text}
                                                        disabled={this.state.readOnly}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6 mb-2">

                                                <b className="text-primary">เอกสารที่ท่านต้องนำมาในวันรับรถ</b>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ driver_license: e.target.checked }) }}
                                                        checked={this.state.driver_license}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">ใบขับขี่คนขับ</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ copy_license_plate: e.target.checked }) }}
                                                        checked={this.state.copy_license_plate}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">สำเนาทะเบียนรถ</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ insurance_policy: e.target.checked }) }}
                                                        checked={this.state.insurance_policy}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">กรมธรรม์ ประกัน</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ id_card_owner: e.target.checked }) }}
                                                        checked={this.state.id_card_owner}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">บัตรประชาชน เจ้าของรถ</label>
                                                </div>
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="checkbox"
                                                        onChange={(e) => { this.setState({ copy_certified_company: e.target.checked }) }}
                                                        checked={this.state.copy_certified_company}
                                                        disabled={this.state.readOnly}
                                                    />
                                                    <label className="ms-2">ถ้าผู้ถือกรรมสิทธิ์เป็นนามบริษัทจำเป็นต้องใช้สำเนารับรองบริษัท</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {this.state.tab === 4 && (
                                    <div className="col-12">
                                        <b className="text-primary">ข้อมูลผู้รับรองการส่งรถ</b>
                                        <div className="row mb-2">
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">ชื่อผู้รับรถ:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        this.setState({ cs_full_name: e.target.value });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_full_name}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">อายุ:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) {
                                                            return
                                                        }
                                                        this.setState({ cs_age: Number(e.target.value) });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_age}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">ความเกี่ยวข้องกับผู้รับรถ:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        this.setState({ cs_relation: e.target.value });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_relation}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">ที่อยู่:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        this.setState({ cs_addess: e.target.value });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_addess}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">หมู่ที่:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        this.setState({ cs_village: e.target.value });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_village}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">ถนน:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    onChange={(e) => {
                                                        this.setState({ cs_street: e.target.value });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_street}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>

                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">จังหวัด : </label>
                                                <Select
                                                    className="form-control select-search"
                                                    styles={select_style}
                                                    options={province.map(item => { { return { value: item.province_name, label: item.province_name } } })}
                                                    onChange={(e) => {
                                                        this.setState({ cs_province: e, cs_district: null, cs_sub_district: null });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_province}
                                                    isDisabled={this.state.readOnly}
                                                ></Select>
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100"> อำเภอ / เขต : </label>
                                                <Select
                                                    className={"form-control select-search" + (this.state.cs_province ? "" : " bg-contain")}
                                                    styles={select_style}
                                                    options={district.filter(item => this.state.cs_province && this.state.cs_province.value === item.province_name).map(item => { { return { value: item.district_name, label: item.district_name, province_name: item.province_name } } })}
                                                    onChange={(e) => {
                                                        this.setState({ cs_district: e, cs_sub_district: null });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_district}
                                                    isDisabled={!this.state.cs_province || this.state.readOnly}
                                                ></Select>
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">ตำบล / แขวง : </label>
                                                <Select
                                                    className={"form-control select-search" + (this.state.cs_district ? "" : " bg-contain")}
                                                    styles={select_style}
                                                    options={subdistrict.filter(item => this.state.cs_district && this.state.cs_district.value === item.district_name).map(item => { { return { value: item.sub_district_name, label: item.sub_district_name, district_name: item.district_name } } })}
                                                    onChange={(e) => {
                                                        this.setState({ cs_sub_district: e });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_sub_district}
                                                    isDisabled={!this.state.cs_district || this.state.readOnly}
                                                ></Select>
                                            </div>
                                            <div className="col-6 col-md-3 col-lg-2 mb-2">
                                                <label className="w-100">เบอร์โทรศัพท์:</label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    placeholder=""
                                                    maxLength={10}
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) {
                                                            return
                                                        }
                                                        this.setState({ cs_phone: e.target.value });
                                                        setTimeout(() => {
                                                            this.onSendCar();
                                                        }, 10);
                                                    }}
                                                    value={this.state.cs_phone}
                                                    disabled={this.state.readOnly}
                                                />
                                            </div>
                                        </div>
                                        <div className="d-flex">
                                            <div className="me-3">
                                                <b className="text-primary mb-2">ลายเซ็นต์ผู้รับรถ</b>
                                                {this.state.signature_get_car ? (
                                                    <div className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 border-primary d-flex align-items-center justify-content-center bg-light mb-2">
                                                        <div className="position-relative wpx-150 hpx-150 d-flex justify-content-center align-items-center">
                                                            <img alt="ลายเซ็นต์" src={this.state.signature_get_car.includes("https://") ? this.state.signature_get_car : "data:image/png;base64," + this.state.signature_get_car} className="wpx-140 hpx-140 overflow-hidden" style={{ objectFit: "contain" }}></img>
                                                            {!this.state.readOnly && (
                                                                <div className="icon bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ signature_get_car: "" }) }}>
                                                                    {"\uf00d"}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 d-flex align-items-center justify-content-center bg-light"
                                                        onClick={() => { if (!this.state.readOnly) { this.setState({ type_signature: "signature_get_car", modal_signature: true }) } }}
                                                    >
                                                        <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                        <label className="text-secondary pointer">ลายเซ็นต์</label>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="me-3">
                                                <b className="text-primary mb-2">ลายเซ็นต์ผู้ทำการซ่อม</b>
                                                {this.state.signature_repair ? (
                                                    <div className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 border-primary d-flex align-items-center justify-content-center bg-light mb-2">
                                                        <div className="position-relative wpx-150 hpx-150 d-flex justify-content-center align-items-center">
                                                            <img alt="ลายเซ็นต์" src={this.state.signature_repair.includes("https://") ? this.state.signature_repair : "data:image/png;base64," + this.state.signature_repair} className="wpx-140 hpx-140 overflow-hidden" style={{ objectFit: "contain" }}></img>
                                                            {!this.state.readOnly && (
                                                                <div className="icon bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ signature_repair: "" }) }}>
                                                                    {"\uf00d"}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 d-flex align-items-center justify-content-center bg-light"
                                                        onClick={() => { if (!this.state.readOnly) { this.setState({ type_signature: "signature_repair", modal_signature: true }) } }}
                                                    >
                                                        <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                        <label className="text-secondary pointer">ลายเซ็นต์</label>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="me-3">
                                                <b className="text-primary mb-2">ลายเซ็นต์พยาน</b>
                                                {this.state.signature_witness ? (
                                                    <div className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 border-primary d-flex align-items-center justify-content-center bg-light mb-2">
                                                        <div className="position-relative wpx-150 hpx-150 d-flex justify-content-center align-items-center">
                                                            <img alt="ลายเซ็นต์" src={this.state.signature_witness.includes("https://") ? this.state.signature_witness : "data:image/png;base64," + this.state.signature_witness} className="wpx-140 hpx-140 overflow-hidden" style={{ objectFit: "contain" }}></img>
                                                            {!this.state.readOnly && (
                                                                <div className="icon bg-danger text-white position-absolute wpx-30 hpx-30 d-flex justify-content-center align-items-center rounded-circle" style={{ top: -8, right: -8 }} onClick={() => { this.setState({ signature_witness: "" }) }}>
                                                                    {"\uf00d"}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="rounded-lg me-2 wpx-150 hpx-150 pointer card border-2 d-flex align-items-center justify-content-center bg-light"
                                                        onClick={() => { if (!this.state.readOnly) { this.setState({ type_signature: "signature_witness", modal_signature: true }) } }}
                                                    >
                                                        <label className="icon text-secondary pointer">{"\uf0ee"}</label>
                                                        <label className="text-secondary pointer">ลายเซ็นต์</label>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>)}
                                {this.state.tab === 5 && (
                                    <div className="col-12">
                                        <div className="table-responsive pb-5 rounded-lg">
                                            <table className="table table-borderless table-striped">
                                                <thead className="bg-primary">
                                                    <tr>
                                                        <th className="text-center text-white">วันที่</th>
                                                        <th className="text-center text-white">รายการ</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.history_list && this.state.history_list.map((item, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">{item.datetime_create ? format_date(item.datetime_create, "dd/mm/yyyy hh:mm") + " น." : "-"}</td>
                                                            <td className="text-center">{item.event_detail ? item.event_detail : "-"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>)}
                                {this.state.tab === 6 && (
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col mb-2">
                                                <div className="card pointer rounded border-primary px-3 py-2 hover-primary" onClick={() => { report_04(this.state) }} style={{ minWidth: 190 }}>
                                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                                        <h6 className="text-primary"><b>ใบรับรถ</b></h6>
                                                        <div className="wpx-60 hpx-60 rounded-circle bg-primary-light d-flex align-items-center justify-content-center icon text-32 text-primary">
                                                            {"\uf1c1"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col mb-2">
                                                <div className="card pointer rounded border-primary px-3 py-2 hover-primary" onClick={() => { report_05(this.state) }} style={{ minWidth: 190 }}>
                                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                                        <h6 className="text-primary"><b>ใบนัด</b></h6>
                                                        <div className="wpx-60 hpx-60 rounded-circle bg-primary-light d-flex align-items-center justify-content-center icon text-32 text-primary">
                                                            {"\uf1c1"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col mb-2">
                                                <div className="card pointer rounded border-primary px-3 py-2 hover-primary" onClick={() => { report_01(this.state) }} style={{ minWidth: 190 }}>
                                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                                        <h6 className="text-primary"><b>ใบเสนอราคา</b></h6>
                                                        <div className="wpx-60 hpx-60 rounded-circle bg-primary-light d-flex align-items-center justify-content-center icon text-32 text-primary">
                                                            {"\uf1c1"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col mb-2">
                                                <div className="card pointer rounded border-primary px-3 py-2 hover-primary" onClick={async() => { 
                                                    
                                                    let signature = !window.location.href.includes(":300") && this.state.signature ? await getimgBase64(this.state.signature) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAMSURBVHicY2BgYAAAAAQAAfYXOFUAAAAASUVORK5CYII=";
                                                    let picture = [];
                                                    if(!window.location.href.includes(":300")){
                                                        for(let i = 0 ; i < 2 ; i++){
                                                            if(this.state.picture_list_bf[i]){
                                                                picture.push(await getimgBase64(this.state.picture_list_bf[i]))
                                                            }else{
                                                                picture.push("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAMSURBVHicY2BgYAAAAAQAAfYXOFUAAAAASUVORK5CYII=");
                                                            }
                                                        }
                                                    }
                                                    report_02({...this.state,picture_list_bf:picture}) }} style={{ minWidth: 190 }}>
                                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                                        <h6 className="text-primary"><b>ใบจ็อบสั่งงาน</b></h6>
                                                        <div className="wpx-60 hpx-60 rounded-circle bg-primary-light d-flex align-items-center justify-content-center icon text-32 text-primary">
                                                            {"\uf1c1"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div><div className="col mb-2">
                                                <div className="card pointer rounded border-primary px-3 py-2 hover-primary" onClick={async () => {
                                                    let signature_get_car2 = !window.location.href.includes("localhost") && this.state.signature_get_car ? await getimgBase64(this.state.signature_get_car) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAMSURBVHicY2BgYAAAAAQAAfYXOFUAAAAASUVORK5CYII=";
                                                    let signature_repair2 = !window.location.href.includes("localhost") && this.state.signature_repair ? await getimgBase64(this.state.signature_repair) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAMSURBVHicY2BgYAAAAAQAAfYXOFUAAAAASUVORK5CYII=";
                                                    let signature_witness2 = !window.location.href.includes("localhost") && this.state.signature_witness ? await getimgBase64(this.state.signature_witness) : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACAQMAAABIeJ9nAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAANQTFRFAAAAp3o92gAAAAF0Uk5TAEDm2GYAAAAMSURBVHicY2BgYAAAAAQAAfYXOFUAAAAASUVORK5CYII=";
                                                    this.setState({
                                                        signature_get_car2: signature_get_car2,
                                                        signature_repair2: signature_repair2,
                                                        signature_witness2: signature_witness2,
                                                    })
                                                    setTimeout(() => {
                                                        report_03(this.state)
                                                    }, 10);
                                                }}>
                                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                                        <h6 className="text-primary"><b>ใบบันทึกรับรอง
                                                            /ใบส่งมอบรถ</b></h6>
                                                        <div className="wpx-60 hpx-60 rounded-circle bg-primary-light d-flex align-items-center justify-content-center icon text-32 text-primary">
                                                            {"\uf1c1"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}
                            </div>
                        </div>
                    </div>
                    <div style={{ height: 100 }}></div>
                </div>
                {!this.state.readOnly && (
                    <div className="body w-100 position-fixed bg-white p-3 d-flex align-items-center justify-content-end" style={{ bottom: 0 }}>
                        <button className="btn btn-outline-orange mx-1 px-5" onClick={() => {
                            Swal.fire({
                                icon: "warning",
                                title: "แจ้งเตือน",
                                text: "ต้องการเคลียร์ข้อมูลทั้งหมดหรือไม่",
                                confirmButtonText: "ตกลง",
                                cancelButtonText: "ยกเลิก",
                                showCancelButton: true,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.href = "/manage-repair/repair/create"
                                }
                            });
                        }}>
                            เคลียร์ข้อมูล
                        </button>
                        <button className="btn btn-orange mx-1 px-5" onClick={() => {
                            if (this.state.product_id ||
                                this.state.qty ||
                                this.state.price ||
                                this.state.estimated_price) {
                                alert("warning", "แจ้งเตือน", "รายการสินค้ายังไม่ได้กดเพิ่มเข้าในตาราง");
                                return
                            }
                            if (this.state.job_id) {
                                this.Update();
                            } else {
                                this.Create();
                            }
                        }}>
                            บันทึก
                        </button>
                    </div>
                )}

                {/* แก้ไขลายเซ็น */}
                < Modal show={this.state.modal_signature} >
                    <Modal.Header> <Modal.Title> <b>ลายเซ็น</b> </Modal.Title> </Modal.Header>
                    <Modal.Body>
                        <div className="w-100 card border-2 border-orange d-flex align-items-center justify-content-center" style={{ height: 500 }}>
                            <SignatureCanvas
                                penColor='black'
                                canvasProps={{ height: 500, className: 'w-100 sigCanvas' }}
                                clearOnResize={false}
                                ref={(ref) => { this.sigPad = ref }}
                                onEnd={(e) => { this.trim() }} />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="w-100 d-flex">
                            <div className="w-50 pe-1">
                                <button className="btn btn-outline-danger w-100" onClick={() => { this.setState({ modal_signature: false }) }}>
                                    ยกเลิก
                                </button>
                            </div>
                            <div className="w-50 ps-1">
                                <button className="btn btn-danger w-100" onClick={() => { this.setState({ modal_signature: false }) }}>
                                    บันทึก
                                </button>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal >
            </div >
        )
    }
}
